import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('gemule_token'));
    const [isLoading, setIsLoading] = useState(true);

    const fetchUser = async () => {
        if (!token) return;
        try {
            const apiUrl = import.meta.env.VITE_CLOUD_API_URL || '/api';
            const res = await fetch(`${apiUrl}/user/me`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const userData = await res.json();
                setUser(userData);
                localStorage.setItem('gemule_user', JSON.stringify(userData));
            } else {
                logout();
            }
        } catch (e) {
            console.error('Failed to parse user session', e);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (token) {
            fetchUser();
        } else {
            setIsLoading(false);
        }
    }, [token]);

    const login = (jwtToken, userData) => {
        setToken(jwtToken);
        setUser(userData);
        localStorage.setItem('gemule_token', jwtToken);
        localStorage.setItem('gemule_user', JSON.stringify(userData));
    };

    const logout = () => {
        setToken(null);
        setUser(null);
        localStorage.removeItem('gemule_token');
        localStorage.removeItem('gemule_user');
    };

    return (
        <AuthContext.Provider value={{ user, token, isLoggedIn: !!token, isLoading, login, logout, fetchUser }}>
            {children}
        </AuthContext.Provider>
    );
};
